import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { NAV } from '../data/mock';

const DESKTOP_NAV = [
  { label: 'Destinations', path: '/destinations' },
  { label: 'Services', path: '/services' },
  { label: 'Find Team', path: '/team' },
  { label: 'Certified', path: '/certified' },
  { label: 'Real Weddings', path: '/real-weddings' },
  { label: 'Mirror AI', path: '/mirror-ai' },
  { label: 'About', path: '/about' },
  { label: 'Journal', path: '/journal' },
];

function DesktopNav({ transparent, currentPath }) {
  return (
    <nav className="hidden xl:flex items-center gap-5 2xl:gap-7">
      {DESKTOP_NAV.map((n) => (
        <Link
          key={n.path}
          to={n.path}
          className={`link-underline whitespace-nowrap text-[11px] 2xl:text-[12px] uppercase tracking-[0.16em] font-medium transition-colors ${transparent ? 'text-[#faf4ea] hover:text-[#ffeabf]' : 'text-[#053e49] hover:text-[#a6894f]'} ${currentPath === n.path ? 'text-[#c3a66d]' : ''}`}
        >
          {n.label}
        </Link>
      ))}
    </nav>
  );
}

function MobileMenu({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-[#053e49] z-50 flex flex-col">
      <div className="flex items-center justify-between px-6 md:px-10 h-20 border-b border-[#0b5260]">
        <Logo dark size="md" />
        <button onClick={onClose} aria-label="Close menu"><X size={24} className="text-[#faf4ea]" /></button>
      </div>
      <nav className="flex-1 overflow-y-auto px-8 py-10 flex flex-col gap-5">
        {NAV.map((n) => (
          <Link key={n.path} to={n.path} className="text-[#faf4ea] font-serif text-3xl md:text-4xl hover:text-[#c3a66d] transition-colors">{n.label}</Link>
        ))}
        <Link to="/plan" className="btn-gold mt-6 self-start">Start Planning</Link>
      </nav>
    </div>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  const onHome = location.pathname === '/';
  const transparent = onHome && !scrolled;

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${transparent ? 'bg-transparent' : 'bg-[#faf4ea]/95 backdrop-blur-md border-b border-[#e8e0d2]'}`}>
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center"><Logo dark={transparent} size="md" /></Link>

        <DesktopNav transparent={transparent} currentPath={location.pathname} />

        <div className="hidden xl:flex items-center gap-4 shrink-0">
          <Link to="/plan" className="btn-gold whitespace-nowrap">Start Planning</Link>
        </div>

        <button className="xl:hidden" onClick={() => setOpen(true)} aria-label="Open menu">
          <Menu size={24} className={transparent ? 'text-[#faf4ea]' : 'text-[#053e49]'} />
        </button>
      </div>

      <MobileMenu open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
